/**
 * Attaches focus event listeners to all valid text input elements within the given DOM node.
 * When focused, the input's text will be automatically selected.
 *
 * This function filters input elements that are not of type "checkbox", do not have the
 * class "timeInput", do not already have the "initedCustomFocus" attribute, and are not
 * in "readonly-mode". The eligible inputs are then set up to select their text content
 * upon receiving focus.
 *
 * After successfully initializing an input, an attribute "initedCustomFocus" is added
 * to prevent reinitialization.
 *
 * @param {Element} node - The parent DOM node containing the potential input elements
 *                         to be initialized.
 * @returns {void}
 */
export const selectTextInputsOnFocus = (node: Element): void => {
  (
    node.querySelectorAll(
      'input:not([type="checkbox"]):not(.timeInput):not([initedCustomFocus]):not(.readonly-mode)',
    ) as NodeListOf<HTMLInputElement>
  ).forEach((input: HTMLInputElement) => {
    input.addEventListener('focus', () => input.select());
    input.setAttribute('initedCustomFocus', 'true');
  });
};
